"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleWithAside = void 0;
var React = require("react");
var ArticleWithAside_styles_1 = require("./ArticleWithAside.styles");
var ArticleWithAside = function (_a) {
    var RenderArticleContents = _a.RenderArticleContents, RenderAsideLinks = _a.RenderAsideListItems, Position = _a.Position;
    return (React.createElement(ArticleWithAside_styles_1.Section, null,
        React.createElement(ArticleWithAside_styles_1.Aside, null,
            React.createElement(ArticleWithAside_styles_1.UL, { Position: Position }, RenderAsideLinks.map(function (PageLink, index) {
                return React.createElement(ArticleWithAside_styles_1.LI, { key: index }, PageLink);
            }))),
        React.createElement(ArticleWithAside_styles_1.Article, null,
            React.createElement(RenderArticleContents, null))));
};
exports.ArticleWithAside = ArticleWithAside;
